import React from 'react'
import {Hsn, Price, Total, AddPurchaseRow, Cgst, Igst, Sgst} from './rowelements/others'
import BarcodeElement from '../invoice/rowelements/barcodeelement'
import {DiscountPercent, DiscountValue} from '../invoice/rowelements/discount'
import CommonItemLevelInput, {CommonInvoiceLevelCheck, CommonItemLevelTextInput, CommonItemLevelInputNumber} from '../commons/commoninput'
import NameElement from './rowelements/nameelement'
import SupplierElement from './rowelements/supplierelement'
import OutState, {AddCess} from './rowelements/outstate'
import PurchaseTotal from './rowelements/purchasetotal'
import PurchaseBasicRate from './rowelements/purchasebasicrate'
import PurchaseRate from './rowelements/purchaserate'
import CessPercentage from './rowelements/cess'
import PurchaseDate from './rowelements/purchasedate'
import QuantityElement from './rowelements/quantity'
import Discount from './rowelements/discount'
import {Loader, round} from '../../utils/misc'
import {Link } from 'react-router-dom'
import {getToken, getUserProfile, getUserSettings} from '../../storage'
import {GET, POST} from '../../utils/ajax'
import {NotificationManager} from 'react-notifications'
import {API_BASE_URL} from '../../constants'
import {basicRate, basicRateWithDiscountPct, basicRateWithDiscountValue, calculateSellingPrice, calculateDiscount} from '../../utils/calculator'
import axios from 'axios'
import {PaymentModal} from '../modal/modal'
class ResponsiveRow extends React.Component {

  render() {
      let item = this.props.item
      let purchase = this.props.purchase
      let td_gst

      let sgst_classname = "col-xs-6"
      let igst_classname = "col-md-12"
      let cess
      if(purchase.add_cess) {
        sgst_classname = "col-xs-4"
        igst_classname = "col-xs-6"
        cess = <div className={purchase.is_igst ? igst_classname: sgst_classname}>
          <label className="hidden-md hidden-lg mtop">Cess %</label>
           <CessPercentage item={item} onChangeCallback={this.props.handleUpdateQuantity} />
        </div>
      }
      let tcs
      if(purchase.add_tcs) {
        tcs = <CommonItemLevelInput placeholder="TCS Percentage" name="tcs_pct" type="number" item={item} onChangeCallback={this.props.handleUpdateQuantity} />
      }


      if(true) {
        td_gst = <div className="row">
            <div className={igst_classname}>
              <label className="hidden-md hidden-lg mtop">GST</label>
               <Igst item={item}  />
            </div>
            {cess}
            {tcs}
        </div>
      }
      else {
        td_gst = <div className="row">
              <div className={sgst_classname}>
                <label className="hidden-md hidden-lg mtop">CGST</label>
                 <Cgst item={item}  />
              </div>
              <div className={sgst_classname}>
                <label className="hidden-md hidden-lg mtop">SGST</label>
                 <Sgst item={item}  />
              </div>
              {cess}
              {tcs}
            </div>
      }


      let inputElement = <NameElement item={item} onAddCallback={this.props.handleUpdateQuantity} requireRates={true} settings={this.props.settings} />
      if(this.props.barcodeInput) {
        inputElement = <div><BarcodeElement item={item} items={this.props.items} onAddCallback={this.props.handleAddBarcodeItem} purchase={true} />
        <small><i>{item.name}</i></small>
        </div>
      }

      let discountHeader = "Disc"
      let discountRender = <Discount item={item} onChangeCallback={this.props.handleUpdateQuantity} />
      let priceRender = <CommonItemLevelInputNumber placeholder="Taxable price" name="price" item={item} onChangeCallback={this.props.handleUpdateTaxablePrice} />
      if(this.props.discountMode === "percentage") {
        discountHeader = "Disc %"
        discountRender = <div>
            <DiscountPercent item={item} onChangeCallback={this.props.handleUpdateQuantity} />
            <DiscountValue item={item} />
        </div>
        priceRender = <Price item={item} />
      }

      return <div className="responsive-row">
        <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-3">
                <label className="hidden-md hidden-lg mtop">Name</label>
                {inputElement}
              </div>
              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">HSN</label>
                <Hsn item={item} />
              </div>
              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">Quantity</label>

                <CommonItemLevelInputNumber item={item} name="quantity" item={item} onChangeCallback={this.props.handleUpdateQuantity} />
              </div>
              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">Unit Rate</label>
                <PurchaseBasicRate item={item} onChangeCallback={this.props.handleUpdateBasicRate} />
              </div>

              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">Unit Rate With Tax</label>
                <PurchaseRate item={item} onChangeCallback={this.props.handleUpdatePurchasePrice} />
              </div>

              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">{discountHeader}</label>
                {discountRender}
              </div>
              <div className="col-xs-6 col-sm-2 col-md-1">
                <label className="hidden-md hidden-lg mtop">Taxable Price</label>
                {priceRender}
              </div>

              <div className="col-xs-6 col-sm-4 col-md-1">
                {td_gst}
              </div>
              <div className="col-xs-6 col-sm-4 col-md-1">
                <label className="hidden-md hidden-lg mtop">Total</label>
                <Total item={item} />
              </div>
              <div className="col-xs-6 col-sm-4 col-md-1 mtop">
                <button className="btn btn-danger btn-xs" onClick={(e)=>{this.props.deleteRow(item.tableIndex)} } >Delete</button>
              </div>


        </div>
      </div>



  }
}


class ResonsiveHeader extends React.Component {
  render() {
    let purchase = this.props.purchase

    let igst_header
    let sgst_classname = "col-xs-6"
    let igst_classname = "col-md-12"
    let cess
    if(purchase.add_cess) {
      sgst_classname = "col-xs-4"
      igst_classname = "col-xs-6"
      cess = <div className={purchase.is_igst? igst_classname : sgst_classname}>Cess %</div>
    }

    if(true) {
      igst_header = <div className="row"><div className={igst_classname}>GST</div>{cess}</div>
    }
    else {
      igst_header = <div className="row">
                      <div className={sgst_classname}>CGST</div>
                      <div className={sgst_classname}>SGST</div>
            {cess}
          </div>
    }

    let discountHeader= "Disc"
    if(this.props.discountMode === "percentage") {
      discountHeader = "Disc %"
    }

    return <div className="responsive-header hidden-xs hidden-sm"><div className="row">
          <div className="col-xs-12 col-sm-6 col-md-3">
            Name
          </div>
          <div className="col-xs-6 col-sm-2 col-md-1">
            HSN/SAC
          </div>
          <div className="col-xs-6 col-sm-2 col-md-1">
            Quantity
          </div>
          <div className="col-xs-6 col-sm-2 col-md-1">
            Unit Rate
          </div>

          <div className="col-xs-6 col-sm-2 col-md-1">
            Unit Rate With Tax
          </div>

          <div className="col-xs-6 col-sm-2 col-md-1">
            {discountHeader}
          </div>
          <div className="col-xs-4 col-sm-2 col-md-1">
            Taxable Price
          </div>

          <div className="col-xs-4 col-sm-4 col-md-1">
            {igst_header}
          </div>
          <div className="col-xs-4 col-sm-4 col-md-1">
            Total
          </div>
          <div className="col-xs-6 col-sm-4 col-md-1">
          </div>
    </div></div>

  }
}


export default class Purchase extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      loading:true,
      showPayments:false,
      purchase: {
        supplier_bill_no:""

      }
    }
    this.handleSupplierChange = this.handleSupplierChange.bind(this)
    this.handleDateChange= this.handleDateChange.bind(this)
    this.handleOutStateChange = this.handleOutStateChange.bind(this)
    this.handleAddCessChage = this.handleAddCessChage.bind(this)
    this.handleSupplierBillChange = this.handleSupplierBillChange.bind(this)
    this.handleUpdateItem = this.handleUpdateItem.bind(this)
    this.modifyItemState = this.modifyItemState.bind(this)
    this.handleAddItem = this.handleAddItem.bind(this)
    this.handleDeleteItem = this.handleDeleteItem.bind(this)
    this.handleAddRow = this.handleAddRow.bind(this)
    this.handleCalculateTotal = this.handleCalculateTotal.bind(this)
    this.handleUpdateQuantity = this.handleUpdateQuantity.bind(this)
    this.handleUpdateBasicRate = this.handleUpdateBasicRate.bind(this)
    this.handleUpdatePurchasePrice = this.handleUpdatePurchasePrice.bind(this)
    this.getDiscount = this.getDiscount.bind(this)
    this.deletePurchase = this.deletePurchase.bind(this)
    this.handleShowPayments = this.handleShowPayments.bind(this)
    this.submit = this.submit.bind(this)
  }

  handleParamChange = ( k,v) => {

    let currentItem = this.state.purchase
    let existingParams = this.state.purchase.additional_params
    if(typeof existingParams !== "undefined" && existingParams !== null) {
        existingParams = existingParams.filter(param => {
          return param.key !==k
        })
    }
    else {
      existingParams = []
    }

    existingParams.push({key:k, value:v})

    currentItem['additional_params'] = existingParams
    this.setState({purchase:currentItem})
    if(k === "lean_pct") {
      this.handleLeanPct(v)
    }
    if(k === "lean_pct_cst") {
      this.handleLeanPctCst(v)
    }

  }

  handleLeanPctCst = (lean_pct) => {
    let purchase = this.state.purchase
    const purchaseSet = purchase.purchaseitem_set
    if(purchaseSet.length === 2) {

      let first = purchaseSet[0]

      let second = purchaseSet[1]
      second.quantity = parseFloat(parseFloat(first.quantity * (lean_pct)/100).toFixed(2))
      // first.quantity = parseFloat( parseFloat(first.quantity - second.quantity).toFixed(2))
      // purchaseSet[0] = first
      // purchaseSet[1] = second
      // purchase.purchaseitem_set = purchaseSet
      // this.setState({purchase:purchase})
      // this.handleUpdateQuantity(first)
      this.handleUpdateQuantity(second)

    }
  }

  handleLeanPct = (lean_pct) => {
    let purchase = this.state.purchase
    const purchaseSet = purchase.purchaseitem_set
    if(purchaseSet.length === 2) {

      let first = purchaseSet[0]

      let second = purchaseSet[1]
      second.quantity = parseFloat(parseFloat(first.quantity * (lean_pct)/100).toFixed(2))
      first.quantity = parseFloat( parseFloat(first.quantity - second.quantity).toFixed(2))
      // purchaseSet[0] = first
      // purchaseSet[1] = second
      // purchase.purchaseitem_set = purchaseSet
      // this.setState({purchase:purchase})
      this.handleUpdateQuantity(first)
      this.handleUpdateQuantity(second)

    }
  }

  handleUpdateBasicRate(item) {
    // calculate purchase price
    var b = item['purchase_basic_rate']
    if (isNaN(b)) {
      b = 0
    }

      if(typeof item.gst !== "undefined" && item.gst !== null) {
        let gst_pct = parseFloat(item.gst.igst)
        item['purchase_rate'] = calculateSellingPrice(b, gst_pct)
      }
      else {
        item['selling_rate'] = b
      }
      this.handleUpdateQuantity(item)

  }

  handleAddBarcodeItem = (item)=> {
    if(item) {
      this.handleUpdateQuantity(item)
    }
  }


  handleUpdateTaxablePrice = (item) => {

    let afterDiscount = parseFloat(item['price'])

    let discount_value = parseFloat(item['discount_edited'])

    if(isNaN(afterDiscount)) {
      afterDiscount = 0
    }
    if(isNaN(discount_value)){
      discount_value = 0
    }

    let priceBeforeDiscount = afterDiscount + discount_value

    let q = parseFloat(item.quantity)

    let b
    try {
      b = priceBeforeDiscount/q
    } catch (e) {
      b = 0
    }


    item['purchase_basic_rate']  = round(b, 6)

    let gst = item.gst
    if(typeof gst !== "undefined" && gst !== null && gst.type !== "undefined" && gst.type !== null) {
        item['cgst_amount'] = parseFloat( parseFloat(afterDiscount*gst.cgst/100).toFixed(2) )
        item['sgst_amount'] = parseFloat( parseFloat(afterDiscount*gst.sgst/100).toFixed(2) )
        item['igst_amount'] = parseFloat( parseFloat(afterDiscount*gst.igst/100).toFixed(2) )
        let gst_pct = parseFloat(item.gst.igst)
        item['purchase_rate'] = calculateSellingPrice(b, gst_pct)
    }
    // here we know price before discount

    let specific_cess_amount = 0
      if(!this.state.purchase.add_cess) {
        item['cess_amount'] = 0
        item['cess_percentage'] =0
        item['specific_cess_amount'] = 0
      }
      else {
        let cess_percentage = item['cess_percentage']
        if (cess_percentage) {
            item['cess_amount'] = parseFloat(parseFloat(afterDiscount*cess_percentage/100).toFixed(2))
        }
        else {
            item['cess_amount'] = 0
        }

        if(q <=0) {
          specific_cess_amount = 0
        }
        else {
          if(typeof item['specific_cess_amount_edited'] !== "undefined") {
            specific_cess_amount = parseFloat(item['specific_cess_amount_edited'])
            item['specific_cess_amount'] = specific_cess_amount
          }
          else {
            specific_cess_amount = parseFloat(item['specific_cess'] * q)
            item['specific_cess_amount'] = specific_cess_amount
          }
        }
      }


      item['total'] = parseFloat(parseFloat(afterDiscount +item['igst_amount']+item['cess_amount'] + specific_cess_amount).toFixed(2))

      if(item['tcs_pct'] !== "undefined" ) {
        let tcs_pct = item['tcs_pct']
        let tcs_value = parseFloat(parseFloat(item['total']) * parseFloat(tcs_pct)/100).toFixed(2)
        if(isNaN(tcs_value)) {
          item['tcs_value'] = 0
        }
        else {
          item['tcs_value'] = tcs_value
          item['total'] = parseFloat(parseFloat(item['total']) + parseFloat(tcs_value)).toFixed(2)
        }
      }

      this.handleUpdateItem(item)
  }


  handleUpdatePurchasePrice(item) {
    const settings = getUserSettings()
    let discount_in_pct = false
    if(settings && settings.options) {

      if(settings.options.purchase_entry_discount_mode) {
        discount_in_pct = true
      }

    }

    // calculate basic rate
    var s = item['purchase_rate']
    if (isNaN(s)) {
      s = 0
    }
    else {

      if(typeof item.gst !== "undefined" && item.gst !== null) {

          let gst_pct = 0
          if(item.gst.type === "C") {
            gst_pct = parseFloat(item.gst.cgst) + parseFloat(item.gst.sgst)

          }
          else {
            gst_pct = parseFloat(item.gst.igst)
          }

          if(discount_in_pct) {
              item['purchase_basic_rate'] = basicRateWithDiscountPct(s, gst_pct, item['discount_percent'])
          }
          else {
            item['purchase_basic_rate'] = basicRateWithDiscountValue(s, gst_pct, item['discount_value'])
          }

          //item['purchase_basic_rate'] = basicRate(s, gst_pct)

          this.handleUpdateQuantity(item, false)
      }
      else {
        item['purchase_basic_rate'] =s
        this.handleUpdateQuantity(item, false)
      }
    }
  }

  componentDidMount() {

    let params = this.props.match.params
    if(typeof params.purchase_id !== "undefined") {
      this.setState({mode:'edit'})
      document.title = "Edit Purchase " + this.props.match.params.purchase_id
      this.getPurchase(this.props.match.params.purchase_id).then((response)=>{
        if(response.status===200) {
          this.setState({purchase: response.data.purchase, loading:false, purchase_item_tableindex: response.data.purchase.purchaseitem_set.length})
        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }
    else {
        document.title = "Create Purchase "
        this.setState({loading:false})
        this.handleAddRow()
    }

    let settings = getUserSettings()
    let barcodeInput = false
    if(settings) {
      const token = getToken()
      if(settings.options && settings.options.purchase_entry_barcode_input) {
        GET('/list_items_complete', token).then((resp)=>{
            this.setState({loading:false, items:resp.data.items})
        })
      }
    }

  }

  getPurchase(purchase_id) {
    return axios({
      url: '/get_purchase/?serial='+purchase_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }



  getDiscount(item) {

    const settings = getUserSettings()
    let discount_mode = false
    if(settings && settings.options) {

      if(settings.options.purchase_entry_discount_mode) {
        discount_mode = true
      }

    }

    // calculate discount
    let quantity = parseFloat(item.quantity)
    if(quantity <= 0) {
      item['discount_value'] = 0
    }
    else if( typeof item['discount_percent_edited'] !== "undefined" ) {
      item['discount_percent'] = parseFloat(item['discount_percent_edited'])

      item['discount_value'] = calculateDiscount(item.price, item['discount_percent'])

    }
    else if(discount_mode && typeof item['discount_percent'] !== "undefined" ) {
      item['discount_value'] = calculateDiscount(item.price, item['discount_percent'])
    }
    else if( typeof item['discount_edited'] !== "undefined" ) {
      item['discount_value'] = parseFloat(item['discount_edited'])
    }
    else {
      let discount_set = item.discount_set
      let matchingDiscount
      if(typeof discount_set !== "undefined" && discount_set !== null) {

        // sort discount set with respect to quantity
        discount_set = discount_set.sort((a,b)=>{
          return b.quantity - a.quantity
        })

        for(var i=0; i<discount_set.length; i++) {
          let d = discount_set[i]
          if(quantity >= d.quantity) {
            matchingDiscount = d
            break;
          }
        }

        if(typeof matchingDiscount !== "undefined") {
            // if discount defined in percentage
            if(matchingDiscount.is_percentage) {
              item['discount_percent'] = matchingDiscount.rate
              item['discount_value'] = calculateDiscount(item.price, matchingDiscount.rate)
            }
            else {
              item['discount_value'] = matchingDiscount.value
            }
        }
        else {
              item['discount_value'] = 0
        }

    }
    else {
      item['discount_value'] = 0
    }
  }
}

handleUpdateQuantity(item, calc_purchase_rate=true) {

  // calculate price, cgst, sgst, igst, total
  let gst = item.gst

  var b = parseFloat(item.purchase_basic_rate), q = parseFloat(item.quantity)
  if (isNaN(b)) {
    b = 0
  }
  if (isNaN(q)) {
    q = Number(0)
  }
  item['price']  = parseFloat(parseFloat(b * q).toFixed(2))
  this.getDiscount(item)
  let afterDiscount = item['price']
  if(!isNaN(item['discount_value'])) {
      afterDiscount = item['price'] - parseFloat(item['discount_value'])
  }
  else {
    // not a number
    item['discount_value'] = Number(0)
  }

  item['price'] = parseFloat(afterDiscount).toFixed(2)
  if(afterDiscount <=0) {
    afterDiscount = 0
  }
  if(typeof gst !== "undefined" && gst !== null && gst.type !== "undefined" && gst.type !== null) {
      item['cgst_amount'] = parseFloat( parseFloat(afterDiscount*gst.cgst/100).toFixed(2) )
      item['sgst_amount'] = parseFloat( parseFloat(afterDiscount*gst.sgst/100).toFixed(2) )
      item['igst_amount'] = parseFloat( parseFloat(afterDiscount*gst.igst/100).toFixed(2) )
  }
let specific_cess_amount = 0
  if(!this.state.purchase.add_cess) {
    item['cess_amount'] = 0
    item['cess_percentage'] =0
    item['specific_cess_amount'] = 0
  }
  else {
    let cess_percentage = item['cess_percentage']
    if (cess_percentage) {
        item['cess_amount'] = parseFloat(parseFloat(afterDiscount*cess_percentage/100).toFixed(2))
    }
    else {
        item['cess_amount'] = 0
    }

    if(q <=0) {
      specific_cess_amount = 0
    }
    else {
      if(typeof item['specific_cess_amount_edited'] !== "undefined") {
        specific_cess_amount = parseFloat(item['specific_cess_amount_edited'])
        item['specific_cess_amount'] = specific_cess_amount
      }
      else {
        specific_cess_amount = parseFloat(item['specific_cess'] * q)
        item['specific_cess_amount'] = specific_cess_amount
      }
    }
  }

  let singletaxed_price = parseFloat(parseFloat(afterDiscount + item['igst_amount']+item['cess_amount'] + specific_cess_amount)/(q)).toFixed(2)

  if(calc_purchase_rate) {
      item['purchase_rate'] = singletaxed_price
  }


  item['total'] = parseFloat(parseFloat(afterDiscount +item['igst_amount']+item['cess_amount'] + specific_cess_amount).toFixed(2))

  if(item['tcs_pct'] !== "undefined" ) {
    let tcs_pct = item['tcs_pct']
    let tcs_value = parseFloat(parseFloat(item['total']) * parseFloat(tcs_pct)/100).toFixed(2)
    if(isNaN(tcs_value)) {
      item['tcs_value'] = 0
    }
    else {
      item['tcs_value'] = tcs_value
      item['total'] = parseFloat(parseFloat(item['total']) + parseFloat(tcs_value)).toFixed(2)
    }

  }

  this.handleUpdateItem(item)
}

  handleCalculateTotal(purchase_purchaseitem_set) {

    let total = 0, totalPrice=0, totalCess=0, totalTax=0, totalDiscount=0, totalTcs=0
      if(typeof purchase_purchaseitem_set !== "undefined" && purchase_purchaseitem_set.length ===2 ) {
        // purchase_purchaseitem_set.forEach((item,i)=> {
        //   totalPrice = totalPrice + parseFloat(parseFloat(item.price).toFixed(2))
        //   totalDiscount = totalDiscount + parseFloat(parseFloat(item.discount_value).toFixed(2))
        //   if(item.cess_amount) {
        //       totalCess = totalCess + parseFloat(parseFloat(item.cess_amount).toFixed(2))
        //   }
        //   if(item.specific_cess_amount) {
        //     totalCess = totalCess + parseFloat(parseFloat(item.specific_cess_amount).toFixed(2))
        //   }
        //   if(item.tcs_value) {
        //     totalTcs = totalTcs + parseFloat(item.tcs_value)
        //   }
        //
        //   totalTax = totalTax + parseFloat(parseFloat(item.igst_amount).toFixed(2))
        //   total = total + parseFloat(parseFloat(item.total).toFixed(2))
        // })
        let firstItem = purchase_purchaseitem_set[0]
        let secondItem = purchase_purchaseitem_set[1]
        totalPrice = parseFloat( parseFloat(firstItem.price - secondItem.price).toFixed(2))
        totalTax = parseFloat( parseFloat(firstItem.igst_amount - secondItem.igst_amount).toFixed(2))
        total = parseFloat( parseFloat(firstItem.total - secondItem.total).toFixed(2))
      }

      totalPrice = parseFloat(totalPrice).toFixed(2)
      totalDiscount = parseFloat(totalDiscount).toFixed(2)
      totalCess = parseFloat(totalCess).toFixed(2)
      totalTcs = parseFloat(totalTcs).toFixed(2)
      totalTax = parseFloat(totalTax).toFixed(2)
      total = parseFloat(Math.round(parseFloat(total).toFixed(2))).toFixed(2)
      this.modifyItemState('totalPrice', totalPrice)
      this.modifyItemState('totalDiscount', totalDiscount)
      this.modifyItemState('totalCess', totalCess)
      this.modifyItemState('totalTax', totalTax)
      this.modifyItemState('totalTcs', totalTcs)
      this.modifyItemState('total', total)
  }


  handleAddItemWithDiscount=(item)=> {
    this.getDiscount(item)
    this.handleUpdateItem(item)
  }

  handleUpdateItem(item) {
    if(typeof item.discount_value === "undefined") {
      item['discount_value'] = ""
    }

    let purchase = this.state.purchase
    let purchase_purchaseitem_set
    if(typeof purchase.purchaseitem_set !== "undefined") {
        purchase_purchaseitem_set = purchase.purchaseitem_set.filter(obj=> obj.tableIndex !== item.tableIndex)
    }

    purchase_purchaseitem_set = purchase_purchaseitem_set.concat(item)
    this.modifyItemState('purchaseitem_set', purchase_purchaseitem_set)
    this.handleCalculateTotal(purchase_purchaseitem_set)
  }

  handleDeleteItem(item_index){
    let purchase = this.state.purchase
    let purchase_purchaseitem_set = []
    if(typeof purchase.purchaseitem_set !== "undefined") {
        purchase_purchaseitem_set = purchase.purchaseitem_set.filter((item,i)=> item.tableIndex !== item_index)

        const reIndexed = purchase_purchaseitem_set.map((item,i)=>{
            item['tableIndex'] = i+1
            return item
        })
        this.modifyItemState('purchaseitem_set', reIndexed)
        this.setState({purchase_item_tableindex: purchase_purchaseitem_set.length})
        this.handleCalculateTotal(purchase_purchaseitem_set)
    }

  }

  handleAddItem(item) {
    let purchase = this.state.purchase
    let purchase_purchaseitem_set = []
    if(typeof purchase.purchaseitem_set !== "undefined") {
        purchase_purchaseitem_set= purchase.purchaseitem_set
    }

    purchase_purchaseitem_set.push(item)
    this.modifyItemState('purchaseitem_set', purchase_purchaseitem_set)

  }

  modifyItemState(key, value) {
        let currentPurchase = this.state.purchase
        currentPurchase[key] = value
        this.setState({
          purchase:currentPurchase
       });
  }


  handleSupplierChange(supplier) {
    this.modifyItemState('supplier', supplier)
    let profile = getUserProfile()
    if(profile.tax_type === "G") {
      let gstin = profile.gstin
      let supplier_gstin = supplier.gstin
      if(gstin && supplier_gstin) {
          if(gstin.substring(0,2) !== supplier_gstin.substring(0,2)) {
            this.modifyItemState('is_igst', true)
          }
          else {
            this.modifyItemState('is_igst', false)
          }
      }
    }

  }
  handleOutStateChange(outstate) {
    this.modifyItemState('is_igst', outstate)
  }
  handleAddCessChage(add_cess){
    this.modifyItemState('add_cess', add_cess)
  }
  handleDateChange(date){
    this.modifyItemState('date', date)
  }
  handleSupplierBillChange(e) {
    this.modifyItemState('supplier_bill_no', e.target.value)
  }
  handleShowPayments() {
    this.setState({showPayments: !this.state.showPayments})
  }

  handleAddRow(event) {
    let tableIndex
    if(typeof this.state.purchase_item_tableindex !== "undefined") {
      tableIndex = this.state.purchase_item_tableindex + 1
    }
    else {
      tableIndex = 1
    }
    const emptyData = {hsn:"", quantity:0, mrp:0, gst:{}, serial:0,
      discount_value:0, purchase_basic_rate:0, purchase_rate:0, price:0, tax:0, total:0, tableIndex:tableIndex,
      cgst_amount:0, sgst_amount:0, igst_amount:0, discount_set:[]}
    if(typeof event !== "undefined") {
          emptyData['namefocus'] = true
    }
    this.handleAddItem(emptyData)
    this.setState({purchase_item_tableindex:tableIndex})

  }



  deletePurchase() {
    let confirmation = window.confirm('You are about to delete this purchase !')

    if(confirmation) {
      axios({
        url: '/delete_purchase/',
        method: 'post',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          },
          post: {
            'Content-Type': 'multipart/form-data;'
          }
        },
        data: this.state.purchase
      }).then((response)=> {
        if(response.status === 200) {
            NotificationManager.success("Deleted purchase successfully")
          setTimeout(()=>{
            if(this.state.mode === "edit") {
              this.props.history.goBack()
            }
            else {
                this.props.history.push("/purchases/")
            }
          }, 700)
        }
      }).catch((err)=> {
        console.log(err);
      })
    }

  }

  submit(e) {
    this.setState({'submitting':true})
  let action = e.target.name;
    let apiurl
    if(this.state.mode ==="edit") {
      apiurl  = "/update_purchase/"
    }
    else {
      apiurl  = "/create_new_purchase/"
    }




    axios({
      url: apiurl,
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.purchase
    }).then((response)=> {
      this.setState({'submitting':false})
      if(response.status === 200) {
        let respondedPurchase = response.data.purchase
        if(this.state.mode === "edit") {
            NotificationManager.success("Updated purchase successfully")
        }
        else {
          NotificationManager.success("Created purchase successfully")
        }

        if(action === "saveprint") {
          this.props.history.push("/purchases/preview/"+respondedPurchase.serial+"/?print=true")
        }
        else {
          setTimeout(()=>{
            if(this.state.mode === "edit") {
              this.props.history.goBack()
            }
            else {
                this.props.history.push("/purchases/")
            }
          }, 700)
        }
      }
    }).catch((err)=> {
      this.setState({'submitting':false})
      console.log(err);
    })
  }



  render() {

      let purchase = this.state.purchase
      let settings = getUserSettings()
      let barcodeInput = false
      let discount_mode = "default"
      if(settings) {
        if(settings.options) {

          if(settings.options.purchase_entry_barcode_input) {
              barcodeInput = true
          }

          if(settings.options.purchase_entry_discount_mode) {
            discount_mode = "percentage"
          }
        }

      }
      let submitButton = <input type="submit" className="btn btn-success" value="save" onClick={this.submit} />
      let saveAndPrintButton = <input type="submit" name="saveprint" className="btn btn-success" value="Save & Preview" onClick={this.submit} />
      if(this.state.submitting) {
        submitButton = <input type="submit" className="btn btn-success" value="saving.." disabled />
        saveAndPrintButton = <input type="submit" className="btn btn-success" value="Saving.." disabled />
      }

      let supplier = <SupplierElement purchase={purchase} onAddCallback={this.handleSupplierChange} />

      let rowELements = []
      if(typeof purchase.purchaseitem_set !== "undefined") {

        purchase.purchaseitem_set.sort((a,b)=>{
          return a.tableIndex - b.tableIndex
        })

        rowELements = purchase.purchaseitem_set.map((item, i)=>{

          i++
          return <ResponsiveRow settings={settings} purchase={purchase} items={this.state.items} item={item} rowno={i} key={i} deleteRow={this.handleDeleteItem} barcodeInput={barcodeInput}
          handleUpdateItem={this.handleUpdateItem}
          handleUpdateItem={this.handleAddItemWithDiscount}
          discountMode = {discount_mode}
          handleUpdateTaxablePrice = {this.handleUpdateTaxablePrice}
          handleUpdateQuantity = {this.handleUpdateQuantity}
          handleAddBarcodeItem = {this.handleAddBarcodeItem}
          handleUpdateBasicRate = {this.handleUpdateBasicRate}
          handleUpdatePurchasePrice = {this.handleUpdatePurchasePrice}
           />
        })
      }


      let pageHeader
      let deletePurchaseBtn, previewLink
      let paymentsLink, paymentModal, purchase_additional_params


      if(!this.state.loading) {

        if(settings) {
           let settingOptions = settings.options || {}

           if(settingOptions.purchase_additional_params && settingOptions.purchase_additional_params.length)  {
             purchase_additional_params = settingOptions.purchase_additional_params.map((param, id)=>{

               let defaultValue
               if(purchase.additional_params) {
                  purchase.additional_params.forEach((p)=>{
                   if(p.key == param) {
                     defaultValue = p.value
                   }
                 })
               }

               // form for lean_pct
               let inputField
               if(param === "lean_pct") {
                 inputField = <form onSubmit={(e)=>{
                   e.preventDefault();
                   this.handleParamChange(param, this.refs[param].value)
                 }}
                     >
                    <input ref={param} type="text" defaultValue={defaultValue} className="form-control input-sm" />
                 </form>
               }
               else {
                 inputField = <input ref={param} type="text" defaultValue={defaultValue} className="form-control input-sm" onChange={(e)=>{
                     e.preventDefault();
                     this.handleParamChange(param, this.refs[param].value)
                   }} />
               }

               return <div className="col-sm-6 col-md-4 col-lg-3 mtop ptiny" key={id}><div className="row ">
                     <label className="col-xs-3">
                       {param}
                     </label>
                     <div className="col-xs-9">
                         {inputField}
                     </div>
               </div></div>
             })


           }

        }

        if(this.state.mode === "edit") {
          pageHeader = <h3>{"Edit Purchase  #" + purchase.serial}</h3>
          deletePurchaseBtn = <button className="btn btn-sm btn-danger" onClick={this.deletePurchase}>Delete Purchase</button>
            paymentsLink = <Link to="#" className="btn btn-primary" onClick={this.handleShowPayments}>Payments</Link>
          previewLink = <Link to={"/purchases/preview/"+this.props.match.params.purchase_id} className="btn btn-primary" > Preview</Link>
          paymentModal = <PaymentModal show={this.state.showPayments} handleClose={this.handleShowPayments} purchase={purchase.id} />
        }
        else {
          pageHeader =  <h3>Create New Purchase</h3>
        }



        return <div >
          {paymentModal}
        <section className="medium">
              {pageHeader}
              <ul className="list-inline">
                <li>{paymentsLink}</li>
                <li>{previewLink}</li>
                <li className="pull-right">{deletePurchaseBtn}</li>
              </ul>

        </section>
            <section className="small">
              <div className="row">
                <div className="col-sm-3">
                  <h4>Supplier</h4>
                  {supplier}
                </div>
                <div className="col-sm-2">
                  <h4>Date</h4>
                  <PurchaseDate purchase={purchase} handleDateChange={this.handleDateChange} />
                </div>
                <div className="col-sm-3">
                  <div className="row">
                    <div className="col-md-4">
                      <h4>Out of State Bill ?</h4>
                      <OutState purchase={purchase}  onChangeCallback={this.handleOutStateChange} />
                    </div>
                    <div className="col-md-4">
                      <h4>Add Cess </h4>
                      <AddCess purchase={purchase}  onChangeCallback={this.handleAddCessChage} />
                    </div>
                    <div className="col-md-4">
                      <h4>Add TCS </h4>
                      <CommonInvoiceLevelCheck name="add_tcs" invoice={purchase} onChangeCallback={this.modifyItemState} />
                    </div>
                  </div>
                </div>
                <div className="col-sm-2">
                  <h4>Supplier Invoice No</h4>
                  <input type="text" className="form-control" value={purchase.supplier_bill_no} onChange={this.handleSupplierBillChange} />

                </div>
              </div>
              <div className="row">

                  {purchase_additional_params}

              </div>
            </section>
            <section className="small">

              <div className="row">
                <div className="col-sm-12">
                  <div className="">
                      <ResonsiveHeader purchase={purchase}  discountMode={discount_mode} />
                      {rowELements}

                      <div className="panel-body">
                      <AddPurchaseRow handleAddRow={this.handleAddRow}  />
                      </div>

                      <section className="medium">
                        <div className="row">
                        <div className="col-xs-6  col-sm-6">

                        </div>
                            <div className="col-xs-6  col-sm-3 col-sm-offset-3">
                            <PurchaseTotal purchase={purchase} />
                            </div>
                        </div>
                      </section>

                  </div>

                  <div className="text-right">
                    <ul className="list-inline">
                        <li>{submitButton}</li>
                        <li>{saveAndPrintButton}</li>
                    </ul>
                  </div>
                </div>
              </div>

            </section>


          </div>

      }
      else {
        return <div>
            <Loader />
        </div>
      }



  }
}



// WEBPACK FOOTER //
// ./src/components/purchase/purchaseCustom01.js